import { DEFAULT_HEADER, JWT_TOKEN, MEMBER_ID } from '../const';

export default function authHeader() {
    return {
        ...DEFAULT_HEADER,
        Authorization: localStorage.getItem(JWT_TOKEN) || '',
        memberId: localStorage.getItem(MEMBER_ID) || ''
    };
}
